import { minCharacters } from "./values.config.js";

export const validateSizes = sizes => {
  return (
    typeof sizes[0].value === "string" &&
    typeof sizes[0].name === "string"
  );
};

export const validateImageOptions = optionGroup => {
  return (
    Array.isArray(optionGroup.options) &&
    typeof optionGroup.options[0].optionData.ImageUrl === "string"
  );
};

export const validateRadioOptions = optionGroup => {
  return (
    Array.isArray(optionGroup.options) &&
    typeof optionGroup.options[0].name === "string"
  );
};

export const validateDesignOptions = optionGroup => {
  return (
    Array.isArray(optionGroup.options)
  );
};

export const validateModalType = type => {
  return ["warning", "error", "success", "default"].includes(type);
};

export const validateInlineMessageType = type => {
  return ["warning", "error", "success", "default"].includes(type);
};

export const notesValid = notes => {
  return notes && notes.length >= minCharacters;
};

export const validCart = selectedOptions => {
  // TODO: If we make viewing proof required, add these params: (proofViewed, isWebToPrint)
  // Look through the selected options to determine if all required steps have been completed
  let materialOption = selectedOptions.MATERIAL;
  let optionsArr = Object.values(selectedOptions); // obj to arr
  for (let opt of optionsArr) {
    if (opt.optional || opt.isDesignNotes) {
      // If the option is optional or design notes
      if (!opt.selected) {
        // If the option isn't selected, move on to the next option
        continue;
      } else if (!opt.noteRequired) {
        // If no note is required, move on to the next option
        continue;
      } else if (opt.notes && notesValid(opt.notes)) {
        // If note is long enough, move on to the next option
        continue;
      } else {
        return false;
      }
    } else {
      // Make sure the selected option has something selected
      if (!opt.selected) {
        if (materialOption && materialOption.name.toLowerCase() === 'acrylic' && opt.groupCode.toLowerCase() == 'sobase') {
          continue;
        }
        else {
          return false;
        }
      } else {
        continue;
      }
    }
  }
  // TODO: For making view proof required
  // If the custom is web2print, make sure they have looked at the proof
  // if (isWebToPrint) {
  //   if (!proofViewed) {
  //     return false;
  //   }
  // }
  return true;
};

export const validProof = selectedOptions => {
  // If there are any required notes options that are selected, proof shouldn't be shown
  let options = Object.values(selectedOptions); // obj to arr
  for (let option of options) {
    if (option.selected && option.noteRequired) {
      return false;
    }
  }
  return true;
};
